import React from 'react';
import {
  Stack,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Grid,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { ApplicationCard } from '../common/ApplicationCard';
import { cleanUpID } from '../common/utils';
import PortalLink from '../common/PortalLink';

const LibraryAppGrid = ({ iconPath, location, locationId }) => (
  <Grid id={'universityLibraries__gridContainer_appWrapper_' + locationId} container spacing={2}>
    {location.apps.map((app) => (
      <Grid
        id={'universityLibraries__grid_app_' + locationId + '_' + app.id}
        item
        xs={6}
        md={6}
        lg={6}
        xl={6}
        xxl={6}
        xxxl={6}
        xxxxl={3}
        key={'universityLibraries__grid_app_' + locationId + '_' + app.id}
      >
        <ApplicationCard
          id={'universityLibraries__applicationCard_' + app.id}
          app={app}
          data={{
            icon: iconPath + app.icon,
          }}
          isActive={true}
          showHeart={false}
          showInfo={false}
          showLinks={true}
        />
      </Grid>
    ))}
  </Grid>
);

const LibraryResourceLinks = ({ links, locationId }) => (
  <Stack
    id={'universityLibraries__stack_locationLinks_' + locationId}
    direction={{
      md: 'column',
      sm: 'column',
      lg: 'row',
      xl: 'column',
      xxl: 'column',
      xxxl: 'row',
    }}
    sx={{ width: '100%' }}
    divider={
      <Divider orientation="vertical" flexItem sx={{ borderColor: 'black' }} role="presentation" />
    }
    spacing={0}
    justifyContent="space-around"
    className="text-center"
  >
    {links.map((item) => (
      <PortalLink
        id={'universityLibraries__link_libraryResourceLink_' + item.id}
        key={'universityLibraries__link_libraryResourceLink_' + item.id}
        href={item.link}
        target="_blank"
        underline="hover"
        sx={{
          marginLeft: 0,
          textAlign: 'center',
        }}
        className="noIcon"
        aria-label={item.title}
      >
        {item.title}
      </PortalLink>
    ))}
  </Stack>
);

const LibraryAccordion = ({ iconPath, location }) => {
  const locationId = cleanUpID(location.title);

  return (
    <Accordion
      defaultExpanded={location.isExpand}
      elevation={0}
      id={'universityLibraries__odu_accordion_' + locationId}
      className="myOdu__accordion libraryAccordion"
      sx={{ mt: 1 }}
    >
      <AccordionSummary
        expandIcon={
          <FontAwesomeIcon
            id={'universityLibraries__icon_chevronDown_' + locationId}
            icon={faChevronDown}
            fixedWidth
          />
        }
        id={'universityLibraries__odu_accordionSummary_' + locationId}
        aria-controls={'universityLibraries__odu_accordionDetails_' + locationId}
        sx={{ flexDirection: 'row-reverse', flexGrow: 1 }}
      >
        <Typography
          id={'universityLibraries__text_locationTitle_' + locationId}
          component="h3"
          variant="h6"
          className="myOdu__widget_title"
          sx={{ ml: 1 }}
        >
          {location.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        id={'universityLibraries__odu_accordionDetails_' + locationId}
        sx={{ p: 1 }}
      >
        <LibraryAppGrid iconPath={iconPath} location={location} locationId={locationId} />

        <Box
          id={'universityLibraries__box_spacer_' + locationId}
          className="myOdu__box"
          sx={{
            borderBottom: 0,
            borderRight: 0,
            borderLeft: 0,
            p: 0,
            mt: 2,
          }}
        />
        <LibraryResourceLinks links={location.libraryLinks} locationId={locationId} />
      </AccordionDetails>
    </Accordion>
  );
};

export default LibraryAccordion;
